import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { makeStyles } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
// import ButtonComp from '../../../../components/button';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../../components/loaderpopup/success';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
        // autofocus: 'none !important',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
        '& div': {
            fontFamily: 'Rubik',
            fontSize: '16px',
            color: '#676767',
            fontWeight: '400',
        },
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        padding: '0px',
        '& button': {
            marginRight: '16px !important',
            marginTop: '10px !important',
            marginBottom: '10px !important',
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function CommentDeleting({ deleteRow, row }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    // const [openBox, setOpenBox] = useState(false);
    // const [deleteMsg, setDeleteMsg] = useState('');
    // const [fullWidth, setFullWidth] = React.useState(true);
    // const [maxWidth, setMaxWidth] = React.useState('sm');
    // const vertical = 'top';
    // const horizontal = 'center';
    const formik = useFormik({
        initialValues: {
            comments: '',
        },
        validationSchema: Yup.object().shape({
            comments: Yup.string().required('Comments Fields must not be blank.'),
        }),
        onSubmit: (values) => {
            setShowLoader(true);
            const data = {
                comments: values.comments,
            };
            // console.log("data", data);
            // deleteRow(row, data);
            setTimeout(() => {
                setShowLoader(false);
                setOpen(false);
                setSuccessPop(true);
                deleteRow(row, data);
            }, 2000);
            setTimeout(() => {
                setSuccessPop(false);
                setOpen(false);
            }, 2500);
        },
    });

    const handleClose = () => {
        setOpen(false);
        setShowLoader(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Record deleted successfully" /> : null}

            {/* <Snackbar
                className="deleteError"
                open={openBox}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar> */}
            <Tooltip title="Delete" onClick={handleClickOpen}>
                <IconButton aria-label="delete">
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
            <Dialog
                // fullWidth={fullWidth}
                // maxWidth={maxWidth}
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Are You Sure
                    <div>Do you really want to delete this record?</div>
                </DialogTitle>
                {/* <DialogActions>
                    <Button
                        onClick={handleOk}
                        // onSubmit={formik.handleSubmit}
                        color="primary"
                        style={{ fontFamily: 'Rubik' }}>
                        Ok
                    </Button>
                    <Button onClick={handleClose} color="primary" autoFocus style={{ fontFamily: 'Rubik' }}>
                        Cancel
                    </Button>
                </DialogActions> */}
                <Grid container className="main-container w100">
                    <Grid className="w100">
                        <form className="itecform commentPopMain" onSubmit={formik.handleSubmit}>
                            <div className="itecform-textboxdiv">
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="comments" shrink>
                                        Remarks
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        rowsMin={3}
                                        onChange={formik.handleChange}
                                        name="comments"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.comments}
                                    />
                                    {formik.touched.comments && formik.errors.comments ? (
                                        <span className="itec-validationError">{formik.errors.comments}</span>
                                    ) : null}
                                </FormControl>

                                {/* <div className="commentTextArea">
                            <label className="labelCls">Remarks</label>
                            <br />
                            <TextareaAutosize
                                className="textareaFullWidth"
                                type="text"
                                rowsMin={3}
                                onChange={formik.handleChange}
                                name="comments"
                                onBlur={formik.handleBlur}
                                value={formik.values.comments}
                            />
                            {formik.touched.comments && formik.errors.comments ? (
                                <span className="itec-validationError">{formik.errors.comments}</span>
                            ) : null}
                        </div> */}
                            </div>
                            <DialogActions className={classes.popFoot}>
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    // color="primary"
                                    size="small"
                                    className={classes.button}
                                    // autoFocus
                                    // style={{ fontFamily: 'Rubik' }}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="outlined"
                                    // color="primary"
                                    size="small"
                                    className={classes.button}
                                >
                                    Delete
                                </Button>
                            </DialogActions>
                        </form>
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}
